import { render } from "./CheckAdmin.vue?vue&type=template&id=4427225c&scoped=true"
import script from "./CheckAdmin.vue?vue&type=script&lang=js"
export * from "./CheckAdmin.vue?vue&type=script&lang=js"

import "./CheckAdmin.vue?vue&type=style&index=0&id=4427225c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1910356388/src/ilongevity-backoffice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4427225c"]])

export default __exports__